'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'person-to-portal';
var width = 576;
var height = 512;
var aliases = ["portal-enter"];
var unicode = 'e022';
var svgPathData = 'M312 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM107.9 169.8c2.5-6 8.3-9.8 14.8-9.8l33 0-2.7 9.2-30.7 104.3c-8.9 30.3 9 62 39.6 70l124.7 32.5-52.5 118.2c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L334.3 387c10-22.6-2.6-48.7-26.5-55l-55.4-14.4 26.1-82.7 3.1 6.2c9.5 19 28.9 31 50.1 31l60.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-60.2 0c-3 0-5.8-1.7-7.2-4.4l-29.5-58.9c-14.9-29.8-45.4-48.6-78.7-48.6l-93.8 0c-25.8 0-49.1 15.5-59.1 39.4L33.8 222.8c-5.1 12.2 .7 26.3 12.9 31.4s26.3-.7 31.4-12.9l29.7-71.4zM199 182.8l6.7-22.8 10.7 0c12.1 0 23.3 5.4 30.8 14.5l-41.3 130.9-32-8.3c-4.4-1.1-6.9-5.7-5.7-10L199 182.8zM111.2 391.6c-2.4 6.7-6.5 12.6-12 17.2l-90.7 76c-10.2 8.5-11.5 23.7-3 33.8s23.7 11.5 33.8 3l90.7-76c12-10 21.1-23.1 26.4-37.8l5.2-14.6-11.9-3.1c-12-3.1-23-8.2-32.6-14.9l-5.9 16.4zM452 57.9C464.6 17.8 477.4 16 480 16s15.4 1.8 28 41.9C519.9 96 528 159.1 528 256s-8.1 160-20 198.1c-12.6 40.1-25.4 41.9-28 41.9s-15.4-1.8-28-41.9c-9.1-29-15.9-72.4-18.7-134.1l-48 0c2.8 65.2 10.1 113.8 20.9 148.4 13.5 43 36.6 75.6 73.8 75.6s60.3-32.6 73.8-75.6C567.9 423.3 576 354.4 576 256S567.9 88.7 553.8 43.6C540.3 .6 517.2-32 480-32S419.7 .6 406.2 43.6c-9.9 31.7-16.9 75.2-20.1 132.4l48.1 0c3.2-53.3 9.6-91.7 17.8-118.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonToPortal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;